class Diraction {
  constructor(
    title,
    transfers = [],
    fromData = {
      sort: 1,
      town: "",
      date: "",
      transport: null,
      service: null,
      time: "",
      id: null,
    },
    toData = {
      sort: 2,
      town: "",
      date: "",
      time: "",
      id: null,
    }
  ) {
    this.title = title;
    this.transfers = transfers;
    this.fromData = fromData;
    this.toData = toData;
  }
}

export default Diraction;
